import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/files/$')({

}).lazy(() => import('./$.lazy').then((d) => d.Route));
